<template>
	<div class="home">
		<Loading msg="loading" v-if="!isload" />
		<div class="home_inner" v-else>
			<!-- 头部 -->
			<div class="home_head">
				<div class="share" @click="$parent.routerGo('/share',(actParams = { query: $route.query, pageid: 350 }),{is_access:true,reportEvent_page_id:'350',reportEvent_page_name:'分享海报',reportEvent_report_type:'199基因',reportEvent_first_module:'分享'})"><span class="share_text share_item">我的优秀基因</span>
        <!-- <img src="../assets/images/share_icon.png" class="share_icon share_item" alt=""> -->
        </div>
				<div class="user_info">
					<!-- <img :src="home_data.user_info.avatar" :key="home_data.user_info.avatar" class="user_pic" alt=""> -->
          <div class="user_pic" :style="{'background':'url('+home_data.user_info.avatar+') center/cover'}"></div>
          
					<p class="user_name">{{home_data.user_info.truename}}</p>
				</div>
				<h1 class="gene_result"><span>{{home_data.gene_info.recommend_info.title_by_type_id}}</span></h1>
				<ul class="result_tag" v-show="!(home_data.gene_info.recommend_info.weak_info.type_id==0) || !(home_data.gene_info.recommend_info.excellent_info.type_id==0)">
					<li class="tag" v-show="home_data.gene_info.recommend_info.excellent_info.title">{{home_data.gene_info.recommend_info.excellent_info.title}}</li>
					<li class="tag" v-show="home_data.gene_info.recommend_info.weak_info.title">{{home_data.gene_info.recommend_info.weak_info.title}}</li>
				</ul>
			</div>

			<!-- 底部入口 -->
			<ul class="entry_part">
				<li class="entry_item ignore" @click="$parent.routerGo('/gene',(actParams = { query: $route.query, pageid: 352 }),{is_access:true,reportEvent_page_id:'352',reportEvent_page_name:'基因结果',reportEvent_report_type:'199基因',reportEvent_first_module:'基因结果'})">
					<div class="item_up">
						<h3 class="up_title">基因结果</h3>
						<p class="up_result">我是天生的好皮囊吗？</p>
					</div>
					<img src="../assets/images/gene_entry.png" class="item_down" alt="">
				</li>

        <!-- 购买99的现状检测展示 -->
        <!-- $parent.routerGo('/pheno/',(actParams = { query: $route.query, pageid: 353 }),{is_access:true,reportEvent_page_id:'353',reportEvent_page_name:'现状结果',reportEvent_report_type:'199基因',reportEvent_first_module:'现状结果'}) -->
        <!-- 神策track在表型页执行 -->
        <li class="entry_item" @click="$parent.routerGo('/pheno/',(actParams = { query: $route.query, pageid: 353 }))" v-if="home_data.biaoXingStatus == 1">
					<div class="item_up">
						<h3 class="up_title">现状结果</h3>
						<p class="up_result">我的皮肤目前是什么水平？</p>
					</div>
					<img src="../assets/images/pheno_entry.png" class="item_down" alt="">
				</li>
				<li class="entry_item" @click="$parent.routerGo('/skincarekeypoints',(actParams = { query: $route.query, pageid: 354 }),{is_access:true,reportEvent_page_id:'354',reportEvent_page_name:'护肤方案',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案'})">
					<div class="item_up">
						<h3 class="up_title">护肤方案</h3>
						<p class="up_result">综合推荐、最需要的成分</p>
					</div>
					<img src="../assets/images/skincare_entry.png" class="item_down" alt="">
				</li>
				<li class="entry_item" @click="$parent.routerGo('/genecategory',(actParams = { query: $route.query, pageid: 355 }),{is_access:true,reportEvent_page_id:'355',reportEvent_page_name:'基因有讲究',reportEvent_report_type:'199基因',reportEvent_first_module:'基因有讲究'})">
					<div class="item_up">
						<h3 class="up_title">基因有讲究</h3>
						<p class="up_result">更多基因结果、发现自我特质</p>
					</div>
					<img src="../assets/images/gene_category_entry.png" class="item_down" alt="">
				</li>
        <!-- 更多升级   未购买99的表型检测展示-->
        <li class="entry_item" @click="$parent.routerGo('/moreservices',(actParams = { query: $route.query, pageid: 356 }),{is_access:true,reportEvent_page_id:'356',reportEvent_page_name:'更多升级',reportEvent_report_type:'199基因',reportEvent_first_module:'更多升级'})" v-if="!(home_data.biaoXingStatus == 1)">
					<div class="item_up">
						<h3 class="up_title">现状检测</h3>
						<p class="up_result">了解皮肤现状，监测肌肤变化</p>
					</div>
					<img src="../assets/images/more_services_entry.png" class="item_down" alt="">
				</li>

			</ul>

      <!-- 基因科普 -->
      <div class="gene_science">
        <div class="gene_science_title">关于基因的科普</div>
        <ul class="gene_science_ul">
          <li class="gene_science_info" @click="$parent.routerGo('/geneandsnp',(actParams = { query: $route.query, pageid: 357 }),{is_access:true,reportEvent_page_id:'357',reportEvent_page_name:'什么是基因与位点',reportEvent_report_type:'199基因',reportEvent_first_module:'基因科普'})"><strong>什么是基因与位点?</strong></li>
          <li class="gene_science_info" @click="$parent.routerGo('/whydifferent',(actParams = { query: $route.query, pageid: 358 }),{is_access:true,reportEvent_page_id:'358',reportEvent_page_name:'为嘛结论与现状不一样',reportEvent_report_type:'199基因',reportEvent_first_module:'基因科普'})"><strong>为什么基因结论跟我的现状不一样?</strong></li>
        </ul>
      </div>

		
		</div>

    <!-- 剁手指数更新弹窗 -->
    <!-- <div class="update_layer" v-if="show_update_layer">
      <div class="update_layer_card">
        <img src="../assets/images/close_btn.png" class="update_layer_close_btn" @click="SkipUpdate()" alt="">
        <div class="update_layer_title" v-html="update_title"></div>
        <div class="update_check_btn" @click="UpdateAction()">去查看</div>
      </div>
    </div> -->

	</div>
</template>

<script>
import Loading from "./Loading.vue";
import axios from "axios";
// import sensors from "sa-sdk-javascript";
export default {
  name: "Home",
  data() {
    return {
      isload: false,
      desire_mark:false,  //是否已经查看剁手指数
      pore_mark:false,  //是否已经查看毛孔项目
      show_update_layer:false,  //更细提示弹窗显示
      update_title:"你的剁手指数已上线<br>快来看看你是否天生喜欢买买买！",  //更新提示弹窗文案
      home_data: null
    };
  },
  beforeRouteEnter(to, from, next) {
    let local_SetTime_199 = localStorage.getItem("local_SetTime_199");
    if (local_SetTime_199) {
      if (Date.parse(new Date()) / 1000 - local_SetTime_199 >= 60 * 60 * 24 * 7) {
        console.log(
          Date.parse(new Date()) / 1000 - local_SetTime_199,
          60 * 60 * 24 * 7
        );
        localStorage.clear();
      }
    } else {
      localStorage.setItem("local_SetTime_199", Date.parse(new Date()) / 1000);
      //TODO handle the exception
    }

    next(vm => {
      console.log(111);
      //请求成功时添加首页统计 2019.6.11
      // vm.initActionLog(vm.$route.query.m,424);
      //2019.6.11

      vm
        .$jsonp("/mall/member/account/loginstatus", {
          type: 1
        })
        .then(res => {
          console.log('loginstatus',res);
          //linkflow start
                if(res.mobile){  //linkflow埋点
                var user_mobile = res.mobile,
                user_unionid = res.unionid,
                user_openid = res.openid;
                console.log('loginstatus',res);
                    window.linkflow.identify({
                    externalId: user_mobile, // 外部唯一标识 ，此标识可以做为联系人合并的依据
                    mobilePhone: user_mobile,
                    name: user_mobile,
                    email: null,
                    city: null,
                    country: null,
                    state: null,
                    company: null,
                    industry: null,
                    title: null,
                    department: null,
                    wechatInfo: {    // 如果填写该参数，微信粉丝将会与Identify之前的匿名用户合并
                                openId: user_openid,   // 公众号粉丝openId，非必填，Linkflow会在用户打开网页时发起微信授权从而获得用户openId, 前提条件: 用户必须在微信中打开网页；如果SDK没有开启静默授权，或者不是在微信中打开网页，则可以手动传入此用户的openId。openId+appId可以定位到在linkflow创建连接的公众号粉丝，会将此公众号粉丝与此用户合并。
                                appId: 'wx86cf3dc298536928',      // 公众号appId（该公众号必须已在Linkflow绑定），非必填，如果openId有值，则此字段必填 ；如果SDK没有开启静默授权，或者不是在微信中打开网页，则可以手动传入此值。openId+appId可以定位到在linkflow创建连接的公众号粉丝，会将此公众号粉丝与此用户合并。
                                unionId:user_unionid //非必填，公众号粉丝unionId，如果传入该值，会和系统中相同unionId的微信公众号和小程序用户进行合并
                                },
              
                }, function(){
                    console.log("linkflow identify done");
                    // window.linkflow.sendEvent({
                    //     userLogin: {//自定义事件名称 
                    //         user_mobile:user_mobile
                            
                    //     }        
                    // });
                }
               
                );
            }
          //linkflow end
          window.getCookie("uniskinmall_uid");
          vm.initHome();
        })
        .catch(error => {
          vm.initHome();
        });
    });
  },
  created() {
    console.log("Home created", this);
    //20190918  判断来源 path=shareactivity  分享页面活动落地页
    console.log(location.href);
    let location_path = location.href;
    if(location_path.includes("path=shareactivity")){
      return this.$router.push("/shareactivity");
    }
    this.initHome();
    this.getUpdateLog();
  },
  mounted(){
    // this.LFEvent({is_access:true,reportEvent_page_id:'424',reportEvent_page_name:'199报告首页',reportEvent_report_type:'199基因',reportEvent_first_module:'首页'});
    this.initActionLog(this.$route.query.m,424);
    //20191023 微信推文查看剁手指数
    if(location.href.includes("wx_article_to_desire_199")){
      // this.LFEvent({is_access:true,reportEvent_page_id:'487',reportEvent_page_name:'公众号推文跳转199剁手指数页面',reportEvent_report_type:'199基因',reportEvent_first_module:'基因有讲究'});
      this.initActionLog(this.$route.query.m,487);
      this.$router.push("/desiretobuy");
    }

    //20191113  微信推文到毛孔问题
    if(location.href.includes("wx_article_to_pore_199")){
      // this.LFEvent({is_access:true,reportEvent_page_id:'512',reportEvent_page_name:'公众号推文跳转199毛孔问卷',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',second_module:'皮肤问题'});
      this.initActionLog(this.$route.query.m,512);
      this.$router.push("/poresurvey");
    }
  },
  methods: {
    getUpdateLog:function(){  //获取剁手指数浏览历史
    this.$jsonp("https://www.uniskin.com.cn/mall/member/reportV2/getReportLog")
    .then(json => {
      console.log('desirelog',json);
      if(json.desire_update_mark_199 == 0){  //首次打开
        this.desire_mark = true;
        this.show_update_layer = true;
      }else{
        this.desire_mark = false;
        this.show_update_layer = false;
      }
      if(json.pore199 == 0){  //首次打开
      this.update_title = "拯救毛孔粗大<br>为您提供个性化的毛孔解决方案";
        this.pore_mark = true;
        this.show_update_layer = true;
      }else{
        this.pore_mark = false;
         this.desire_mark = false;
        this.show_update_layer = false;
      }
    })
    .catch(err => {
      console.log(err);
      location.href = "https://www.uniskin.com.cn/mall/member/account/login";
    })

    },
    UpdateAction:function(){
      if(this.pore_mark){
        this.show_update_layer=false;
        this.$parent.routerGo('/poresurvey',{ query: this.$route.query, pageid: 492 },{is_access:true,reportEvent_page_id:'492',reportEvent_page_name:'首页提示毛孔更新-跳转毛孔问卷',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',second_module:'皮肤问题',third_module:'毛孔'});
        return;
      }else if(this.desire_mark){
        this.show_update_layer=false;
        this.$parent.routerGo('/desiretobuy',{ query: this.$route.query, pageid: 483 },{is_access:true,reportEvent_page_id:'483',reportEvent_page_name:'199首页剁手指数更新弹窗跳转199剁手指数页',reportEvent_report_type:'199基因',reportEvent_first_module:'基因有讲究'});
        return;
      }
    },
    SkipUpdate:function(){
      if(this.pore_mark){
        this.show_update_layer=false;
        this.initActionLog(this.$route.query.m,492);
        // this.LFEvent({is_access:true,reportEvent_page_id:'492',reportEvent_page_name:'首页提示毛孔更新-跳转毛孔问卷',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',second_module:'皮肤问题',third_module:'毛孔'});
        return;
      }else if(this.desire_mark){
        this.show_update_layer=false;
        this.initActionLog(this.$route.query.m,483);
        // this.LFEvent({is_access:true,reportEvent_page_id:'483',reportEvent_page_name:'199首页剁手指数更新弹窗跳转199剁手指数页',reportEvent_report_type:'199基因',reportEvent_first_module:'基因有讲究'});
        return;
      }
    },
    initHome: function() {
      let that = this;
      var local_home = JSON.parse(localStorage.getItem("local_home"));
      if (local_home) {
        afterHome(local_home);
      } else {
        that
          .$jsonp(
            "https://www.uniskin.com.cn/reportv2/index/gene_july_one/index"
          )
          .then(json => {
            console.log(json);
            // localStorage.setItem("local_home",JSON.stringify(json));
            afterHome(json);
          })
          .catch(err => {
            console.log(err);
            localStorage.clear();
            location.href =
              "https://www.uniskin.com.cn/mall/member/account/login";
          });
      }
      function afterHome(home_data) {
        if (home_data.code == 0) {
          that.isload = true;
          that.home_data = home_data;
          if((!home_data.flag)){
            alert("暂无检测数据");
            location.href = "https://www.uniskin.com.cn/homepage/sample_progress/199_sample_m.html";
          }
          else if((!home_data.flag) && (home_data.bar_code_type == 2) && (!home_data.flag_199)){
            alert("暂无199检测数据");
            location.href = "https://www.uniskin.com.cn/homepage/sample_progress/199_sample_m.html";
          }else if (!home_data.flag && home_data.biaoXingStatus == 1) {
            //flag为true 时499和199至少存在一个数据  flag_199 为true时有199数据 biaoxingstatus = 1 有表型数据
            return that.$router.push("/pheno");
          }
        } else if (home_data.code == 100) {
          // 未登录
          localStorage.clear();
          alert("请先登录");
          location.href =
            "https://www.uniskin.com.cn/mall/member/account/login";
        } else if (home_data.code == 201) {
          alert("请先绑定样本");
          location.href = "https://www.uniskin.com.cn/mall/member/account/bind";
        }else if(home_data.code == 110){
          alert("请先填写问卷");
          location.href = "https://www.uniskin.com.cn/homepage/questionnaire/questionnaire_uni.html";
        }else if(home_data.code == 111){
          alert("您属于线下用户");
          location.href = "https://www.uniskin.com.cn/homepage/p/index.html";
        }
      }
    },

    initActionLog: function(m, pageid) {
      if (m && pageid)
        return axios.get("/mall/member/reportV2/actionlog", {
          params: { m, pageid }
        });
    },
      LFEvent: function(trackData) {
      console.log(trackData);
      //神策事件追踪
      if (trackData){window.linkflow.sendEvent({"reportEvent":trackData})};
      // if (trackData)
      //   sensors.track('reportEvent',trackData);
    },
  },
  components: {
    Loading
  }
};
</script>
<style lang="less" scoped>
@import "../styles/mixin.less";
@import "../styles/reset.less";
//20191018  剁手指数弹窗
.update_layer{
  position:fixed;
  width:100%;
  height:100%;
  top:0;
  left:0;
  background:rgba(0,0,0,0.3);
  .update_layer_card{
    position:absolute;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
    box-sizing:border-box;
    width:596/50rem;
    padding:88/50rem 30/50rem 74/50rem;
    text-align:center;
    background:#fff;
    .border-radius(15/50rem);
    .shadow;
    .update_layer_close_btn{
      position:absolute;
      right:30/50rem;
      top:30/50rem;
      width:20/50rem;
      height:20/50rem;
      opacity:0.3;
    }
    }
    .update_layer_title{
        font-size:32/50rem;
        line-height:42/50rem;
        color:@font-c-3;
        text-align:center;
        padding-bottom:78/50rem;
    }
    .update_check_btn{
      margin:0 auto;
      width:207/50rem;
      height:60/50rem;
      line-height:60/50rem;
      color:@font-c-f;
      background:@font-c-detail;
      .border-radius(34/50rem);
      font-size:32/50rem;
      text-align:center;
      // .border-1px-34;
    }
}
.home_inner {
  background: @bg_c_m;
}
.home_head {
  background: @bg_c_l;
  padding: 103/50rem 30/50rem 70/50rem;
  .shadow;
  .share {
    position:absolute;
    top:43/50rem;
    right:0;
    width:213/50rem;
    height:60/50rem;
    .border-radius(40/50rem 0 0 40/50rem);
    background:#ff9493;
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-center;
    .share_item {
      .align-items_flex-end;
      .flex_0;
      .align-self_center;
      &.share_text {
        font-size: 26/50rem;
        color: @font-c-f;
        margin-right: 12/50rem;
      }
      &.share_icon {
        width: 28/50rem;
        height: 28/50rem;
        // background:green;
      }
    }
  }
  .user_info {
    text-align: center;
    padding-bottom: 35/50rem;
    .user_pic {
      margin: 0 auto;
      width: 158/50rem;
      height: 158/50rem;
      // background:url("https://www.uniskin.com.cn/mall/uploads/picture/website/headimg/20190730/38efefac1e560c54c65990c9d9dd012f.jpg");
      background-size: 158/50rem 158/50rem;
      background-position: center;
      .border-radius(50%);
    }
    .user_name {
      letter-spacing:0;
      padding-top: 26/50rem;
      font-size: 34/50rem;
      color: @font-c-3;
      line-height: 1em;
      text-align: center;
      font-weight: bold;
    }
  }
  .gene_result {
    text-align: center;
    span {
      letter-spacing:0;
      font-weight: bold;
      font-size: 48/50rem;
      color: @font-c-3;
      line-height: 1.1em;
      border-bottom: 1px solid #ff9493;
    }
  }
  .result_tag {
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-center;
    padding-top: 40/50rem;
    .tag {
      position:relative;
      font-size: 24/50rem;
      color: @font-c-3;
      margin-right: 10/50rem;
      .flex_0;
      box-sizing: border-box;
      padding: 14/50rem 30/50rem;
      .border-radius(30/50rem);
      // .gradient(to right, @start-c-1, @end-c-1);
      &::before{
        content:"";
        display:block;
        width:5px;
        height:5px;
        position:absolute;
        left:0;
        top:50%;
        -webkit-transform:translateY(-50%);
        transform:translateY(-50%);
        .border-radius(50%);
        background:#9757b2;
      }
    }
    .tag:last-child {
      // .gradient(to right, @start-c-5, @end-c-5);
      &:before{
        background:#f07355;
      }
    }
  }
}
.entry_part {
  padding: 62/50rem 29/50rem 57/50rem;
  .display_flex;
  .flex-wrap_wrap;
  .justify-content_flex-justify;
  .ignore {
    .shadow;
  }
  .entry_item {
    background: @bg_c_l;
    width: 326/50rem;
    height: 287/50rem;
    margin-bottom: 43/50rem;
    .border-radius(14/50rem);
    .shadow;
    box-sizing: border-box;
    .item_up,
    .item_down {
      width: 100%;
      height: 50%;
    }
    .item_up {
      box-sizing: border-box;
      padding: 41/50rem 0 37/50rem;
      text-align: center;
      .up_title {
        font-weight: bold;
        font-size: 34/50rem;
        color: @font-c-3;
        line-height: 1em;
        padding-bottom: 9/50rem;
      }
      .up_result {
        font-size: 22/50rem;
        color: @font-c-sub;
        line-height: 1em;
        text-align: center;
      }
    }
    .item_down {
      .border-radius(0 0 14/50rem 14/50rem);
    }
  }
}
.gene_science {
  padding: 0 30/50rem 116/50rem;
  .gene_science_title {
    font-size: 34/50rem;
    line-height: 1em;
    color: @font-c-3;
    font-weight: bold;
    padding-bottom: 40/50rem;
  }
  .gene_science_ul {
    background: @bg_c_l;
    box-sizing: border-box;
    padding: 43/50rem 30/50rem 48/50rem;
    .border-radius(14/50rem);
    .shadow;
  }
  .gene_science_info {
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-start;
    &:first-child {
      margin-bottom: 36/50rem;
    }
    &:before {
      content: "";
      display: block;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: #000;
      .flex_0;
      // .align-items_center;
      .align-self_center;
      margin-right: 13/50rem;
    }
    strong {
      .flex_0;
      // .align-items_center;
      .align-self_center;
      border-bottom: 1px solid @border-c;
      font-size: 30/50rem;
      line-height: 1em;
      color: @font-c-3;
    }
  }
}
</style>
